import classnames from "classnames";
import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import analytics from "web/script/analytics/analytics";
import { gettext } from "web/script/modules/django-i18n";
import SVGIcon from "../svg-icon/svg-icon";
import style from "./read-more-less.css";

function ReadMoreLess({ children, readMoreLabel, readLessLabel, itemAttributes }) {
    const [expanded, setExpanded] = useState(false);
    const [height, setHeight] = useState(0);
    const readMoreLessAreaElement = useRef(null);

    function handleReadMoreLess() {
        setExpanded(!expanded);
        analytics.event("read_more_less", "clicked");
    }

    function needsReadMoreLess() {
        // same as style.collapsedText max-height
        return height >= 190;
    }

    useEffect(() => {
        const currentElement = readMoreLessAreaElement.current;
        if (currentElement != null) {
            // there's no DOM in test environment
            const currentHeight = currentElement.clientHeight || 0;
            setHeight(currentHeight);
        }
    }, []);

    return (
        <div className={style.shortText}>
            <div
                className={classnames(style.expandableText, {
                    [style.expandedText]: expanded,
                    [style.collapsedText]: !expanded,
                })}
                {...itemAttributes}
                ref={readMoreLessAreaElement}
            >
                {children}
                {needsReadMoreLess() && <div className={style.readMoreLessFadeElement} />}
            </div>
            {needsReadMoreLess() && (
                <div className={style.readMoreLessText} onClick={handleReadMoreLess}>
                    {expanded ? readLessLabel : readMoreLabel}
                    <SVGIcon name="round-chevron" rotate={expanded ? 270 : 90} />
                </div>
            )}
        </div>
    );
}

ReadMoreLess.displayName = "ReadMoreLess";

ReadMoreLess.propTypes = {
    children: PropTypes.node,
    readMoreLabel: PropTypes.string,
    readLessLabel: PropTypes.string,
    itemAttributes: PropTypes.object,
};

ReadMoreLess.defaultProps = {
    readMoreLabel: gettext("general.read_more"),
    readLessLabel: gettext("general.read_less"),
    itemAttributes: {},
};

export default ReadMoreLess;
